module.exports = __webpack_public_path__ + "static/img/deposit_n_selected.63efb02c.svg";